import { Component } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: `vp-filter-map-button`,
	templateUrl: './filter-map-button.html',
	imports: [SVG_ICON_IMPORTS, TranslatePipe],
})
export class FilterMapButtonComponent {}
